/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import * as consts from '../../../const';
import PropTypes from 'prop-types';
import userPhotoPlaceholder from '../../../assets/images/icons/user-picture.svg';
import DetailsCard from '../../common/details.card/details.card';

const PeopleDetailsCard = ({ user: { firstName, lastName, username: email } = {} }) => {
  const content = [
    { label: consts.FIRST_NAME, value: firstName },
    { label: consts.LAST_NAME, value: lastName },
    { label: consts.PEOPLE_DETAILS_EMAIL, value: email }
  ];

  return <DetailsCard picture={userPhotoPlaceholder} content={content} cardId="user-management-details-card" />;
};

PeopleDetailsCard.propTypes = {
  user: PropTypes.object.isRequired
};

export default PeopleDetailsCard;
